import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import {
  FormattedMessage,
  AppId,
} from 'base-app'
import { history } from "../../../history"
import BuyInsuranceCarServ from '../../../services/buyInsuranceCar'
import { useSelector } from 'react-redux'

const divStyle = {
  position: 'fixed',
  top: '50%',
  left: '50%'
};

const showAlert = (titleId, contentId, isHaveClose) => {
  return (
    <Modal
      isOpen={true}
      className="modal-dialog-centered"
    >
      <ModalHeader >
        <FormattedMessage id={titleId} />
      </ModalHeader>
      <ModalBody>
        <div className={divStyle}>

        <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.Processing`} />

        </div>
      </ModalBody>

    </Modal>
  )
}

const PaymentWaiting = (props) => {

  const [toggleShow, setToggleShow] = useState(false)
  const {insId} = useSelector(state => state.auth.divayUserInfo);

  useEffect(() => {
    confirmConstract()
  }, [])
  const confirmConstract = async () => {
    const infos = JSON.stringify({
      returnURL: window.location.href,
      insId
    });
    const res = await BuyInsuranceCarServ.confirmConstract(infos)
    if (res.status === 200) {
      if (res.data.contract.contractType === 'CC') {//Bao hiem oto
        if (['ORDER_SUCCESS', 'ALREADY_CONFIRM'].includes(res.data.result)) {
          history.push({
            pathname: '/buy-insurance/car',
            state: { action: "COMPLETE", data: res.data.contract, hmac : res.data.hmac }
          })
        }
        else if (res.data.result === 'TIMEOUT') {
          history.push({
            pathname: '/buy-insurance/car',
            state: { action: "COMPLETE_TIMEOUT" }
          })
        } else {
          // console.log(res)
          history.push({
            pathname: '/buy-insurance/car',
            state: { action: "COMPLETE_FAIL" }
          })
        }

      } else if (res.data.contract.contractType === 'MC') {//Bao hiem xe may
        // Minh xu li cho phan xe may tiep
        //...
        //...
        if (['ORDER_SUCCESS', 'ALREADY_CONFIRM'].includes(res.data.result)) {
          history.push({
            pathname: '/buy-insurance/motor',
            state: { action: "COMPLETE", data: res.data.contract, hmac : res.data.hmac }
          })
        } else if (res.data.result === 'TIMEOUT') {//truong hop timeout
          history.push({
            pathname: '/buy-insurance/motor',
            state: { action: "COMPLETE_TIMEOUT" }
          })
        } else {//trg hop loi
          history.push({
            pathname: '/buy-insurance/motor',
            state: { action: "COMPLETE_FAIL" }
          })
        }
      }

    } else {
      history.push({
        pathname: `/buy-insurance/${res.data.contract.contractType === 'CC' ? 'car' : 'motor'}`,
        state: { action: "COMPLETE_FAIL" }
      })
    }
  }

  return (
    <div className={divStyle}>
      {showAlert(`${AppId.DIVAY_INSURANCE_APP}.NoticeAlertTitle`, `${AppId.DIVAY_INSURANCE_APP}.InfoNotExistsAlertContent`, false)}
    </div>
  )
}
export default PaymentWaiting
